import Form from "../components/Form";
import Sidebar from "../components/Sidebar";

const Home = () => {
    return(
        <>
            

            {/* Main site content: replaced undefined MainSiteContent component */}
            <main className="main-site-content">
                <Sidebar />
                <Form />
            </main>
            {/* Santa bell: add your image to public/assets/img/santa-claus.png */}
        </>
    )
}

export default Home;